// extracted by mini-css-extract-plugin
module.exports = {"mCard":"Rg","image":"Sg","imageNoBackground":"Tg"};